/*
 * common / chart
 */

export function initChart(inputChartData) {

  const employed_val = inputChartData.employed_val;
  const employed_avg = inputChartData.employed_avg;
  const unemployment_val = inputChartData.unemployment_val;
  const unemployment_avg = inputChartData.unemployment_avg;
  const earnings_val = inputChartData.earnings_val;
  const earnings_mdn = inputChartData.earnings_mdn;

  $(window).bind('load', function() {

    /*
     * 検索結果ナレッジパネル Number of people employed
     */
    if (document.getElementById('chartjs_employed') !== null) {

        var chart_1 = document.getElementById('chartjs_employed').getContext('2d');

        var valMin_1 = Math.min.apply(null, employed_val),
            valMax_1 = Math.max.apply(null, employed_val),
            chartMax_1 = valMax_1 + 0.02,
            chartMin_1 = valMin_1 - 0.04;

        // 共通グラデーション
        var gradient = chart_1.createLinearGradient(0, 0, 0, 100);
        gradient.addColorStop(0, 'rgba(190, 219, 245, 0.7)');
        gradient.addColorStop(1, 'rgba(190, 219, 245, 0.15)');

        var chartjs_employed = new Chart(chart_1, {
            type: 'line',
            data: {
                labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                datasets: [{
                    data: employed_val,
                    borderWidth: 2,
                    borderColor: '#408FD8',
                    radius: 0,
                    tension: 0.4,
                    fill: true,
                    backgroundColor: gradient,
                },
                    {
                        labels: '平均',
                        data: employed_avg,
                        type: 'scatter',
                        showLine: true,
                        radius: 0,
                        hoverRadius: 0,
                        borderDash: [5, 5],
                        borderWidth: 1.2,
                        borderColor: '#8D8D8D',
                    },
                ],
            },
            options: {
                animation: false,
                layout: {
                    padding: {top: 5},
                },
                plugins: {
                    legend: {display: false},
                    tooltip: {enabled: false},
                },
                scales: {
                    x: {
                        grid: {display: false},
                        display: false,
                    },
                    y: {
                        grid: {display: false},
                        min: chartMin_1,
                        max: chartMax_1,
                        display: false,
                    },
                },
            },
        });
    }


    /*
     * 検索結果ナレッジパネル Unemployment rate
     */
      if (document.getElementById('chartjs_unemployment') !== null) {
          var chart_2 = document.getElementById('chartjs_unemployment').getContext('2d');

          var valMin_2 = Math.min.apply(null, unemployment_val),
              valMax_2 = Math.max.apply(null, unemployment_val),
              chartMax_2 = valMax_2 + 0.15,
              chartMin_2 = valMin_2 - 0.32;

          var chartjs_unemployment = new Chart(chart_2, {
              type: 'line',
              data: {
                  labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
                  datasets: [{
                      data: unemployment_val,
                      borderWidth: 2,
                      borderColor: '#408FD8',
                      radius: 0,
                      tension: 0.4,
                      fill: true,
                      backgroundColor: gradient,
                  },
                      {
                          data: unemployment_avg,
                          type: 'scatter',
                          showLine: true,
                          radius: 0,
                          hoverRadius: 0,
                          borderDash: [5, 5],
                          borderWidth: 1.2,
                          borderColor: '#8D8D8D',
                      },
                  ],
              },
              options: {
                  animation: false,
                  layout: {
                      padding: {top: 5},
                  },
                  plugins: {
                      legend: {display: false},
                      tooltip: {enabled: false},
                  },
                  scales: {
                      x: {
                          grid: {display: false},
                          display: false,
                      },
                      y: {
                          grid: {display: false},
                          display: false,
                          min: chartMin_2,
                          max: chartMax_2,
                      },
                  },
              },
          });
      }


    /*
     * 検索結果ナレッジパネル Annual Earnings
     */
      if (document.getElementById('chartjs_earnings') !== null) {
          var chart_3 = document.getElementById('chartjs_earnings').getContext('2d');

          var datasets_chart_3 = [{
                  data: earnings_val,
                  borderColor: '#408FD8',
                  hoverBorderColor: '#408FD8',
                  borderWidth: 2,
                  hoverBorderWidth: 0,
                  pointBackgroundColor: '#408FD8',
                  pointHoverBackgroundColor: '#408FD8',
                  pointRadius: [0],
                  hoverRadius: [0],
                  pointBorderWidth: 0,
                  tension: 0.4,
                  fill: true,
                  backgroundColor: gradient,
              }],
              barRange = [0, 10000, 15000, 25000, 35000, 50000, 65000, 75000, 100000, Infinity];
          for (var i = 0; i < barRange.length - 1; i++) {
              if (earnings_mdn >= barRange[i] && earnings_mdn < barRange[i + 1]) {
                  datasets_chart_3[0].pointRadius[i] = '4';
                  datasets_chart_3[0].hoverRadius[i] = '4';
              } else {
                  datasets_chart_3[0].pointRadius[i] = '0';
                  datasets_chart_3[0].hoverRadius[i] = '0';
              }
          }

          var chartjs_earnings = new Chart(chart_3, {
              type: 'line',
              data: {
                  labels: ['', '', '', '', '', '', '', '', ''],
                  datasets: datasets_chart_3,
              },
              options: {
                  animation: false,
                  layout: {
                      padding: {top: 5},
                  },
                  plugins: {
                      legend: {display: false},
                      tooltip: {enabled: false},
                  },
                  scales: {
                      x: {
                          grid: {display: false},
                          display: false,
                      },
                      y: {
                          grid: {display: false},
                          display: false,
                          min: -10,
                      },
                  },
              },
          });
      }

  });

}
